import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import api from "../lib/api";
import { ArrowRight } from "lucide-react";
import { toast } from "sonner";

export default function ForgotPassword() {
  const nav = useNavigate();
  const [step, setStep] = useState(1); // 1: request, 2: reset
  const [mobile, setMobile] = useState("");
  const [code, setCode] = useState("");
  const [newPassword, setNewPassword] = useState("");
  const [busy, setBusy] = useState(false);

  const request = async (e) => {
    e.preventDefault();
    if (!mobile) return;
    setBusy(true);
    try {
      await api.post("/auth/buyer/forgot-password", { mobile });
      toast.success("Reset code sent (if the mobile is registered)");
      setStep(2);
    } catch (err) {
      toast.error(err.response?.data?.detail || "Failed to request reset");
    } finally { setBusy(false); }
  };

  const reset = async (e) => {
    e.preventDefault();
    if (!code || !newPassword) return;
    if (newPassword.length < 6) { toast.error("Password must be at least 6 characters"); return; }
    setBusy(true);
    try {
      await api.post("/auth/buyer/reset-password", { mobile, reset_code: code, new_password: newPassword });
      toast.success("Password updated. Please sign in.");
      nav("/login");
    } catch (err) {
      toast.error(err.response?.data?.detail || "Reset failed");
    } finally { setBusy(false); }
  };

  return (
    <div className="max-w-md mx-auto px-6 py-24" data-testid="forgot-page">
      <p className="label-eyebrow">Password Reset</p>
      <h1 className="font-editorial text-4xl tracking-editorial mt-3 mb-2">
        {step === 1 ? "Forgot password?" : "Enter reset code"}
      </h1>
      <p className="text-sm text-[#5C5C5C] mb-10">
        {step === 1
          ? "We'll send a 6-digit reset code to your registered mobile via WhatsApp."
          : "Enter the 6-digit code we sent to your mobile."}
      </p>

      {step === 1 ? (
        <form onSubmit={request} className="space-y-6" data-testid="forgot-request-form">
          <div>
            <label className="label-eyebrow block mb-1">Mobile Number</label>
            <input className="input-editorial" value={mobile} onChange={(e) => setMobile(e.target.value)} placeholder="+91 98xxxx xxxxx" data-testid="forgot-mobile" />
          </div>
          <button className="btn-clay w-full" disabled={busy} data-testid="forgot-submit">
            {busy ? "Sending..." : "Send Reset Code"} <ArrowRight className="w-4 h-4" strokeWidth={1.5} />
          </button>
        </form>
      ) : (
        <form onSubmit={reset} className="space-y-6" data-testid="forgot-reset-form">
          <div>
            <label className="label-eyebrow block mb-1">6-digit Code</label>
            <input className="input-editorial tracking-widest" value={code} onChange={(e) => setCode(e.target.value)} placeholder="000000" maxLength={6} data-testid="reset-code" />
          </div>
          <div>
            <label className="label-eyebrow block mb-1">New Password</label>
            <input type="password" className="input-editorial" value={newPassword} onChange={(e) => setNewPassword(e.target.value)} placeholder="Min 6 characters" data-testid="reset-newpassword" />
          </div>
          <button className="btn-clay w-full" disabled={busy} data-testid="reset-submit">
            {busy ? "Resetting..." : "Reset Password"} <ArrowRight className="w-4 h-4" strokeWidth={1.5} />
          </button>
          <button type="button" onClick={() => setStep(1)} className="text-xs text-[#5C5C5C] underline">Didn't receive? Resend</button>
        </form>
      )}

      <div className="mt-8">
        <Link to="/login" className="link-slide text-sm text-[#1E2C5A]">← Back to sign in</Link>
      </div>
    </div>
  );
}
